import React, { useState } from 'react';
import "./MyInput.css";

const MyInput = ({ info, isDisabled, onChange }) => {
    // Убираем локальный стейт, так как управлять значением должен родитель
    return (
        <div className={"content"}>
            <div className={"input__block"}>
                <h6>{info.name}</h6>
                <input
                    value={info.value} // Используем переданное значение
                    disabled={isDisabled}
                    onChange={(e) => {
                        if (!isDisabled && onChange) {
                            onChange(e.target.value); // Передаём новое значение в родительский компонент
                        }
                    }}
                    style={{ color: !isDisabled ? "#1D1A27" : "#DFDCE9" }}
                />
            </div>
        </div>
    );
};

export default MyInput;